export const sxConfig = {
  page: {
    minHeight: '100vh',
    bgcolor: '#f4f6f8',
    p: 2,
  },

  card: {
    bgcolor: '#fff',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1.5,
    boxShadow: 'none',
  },
};
